export const enum FeedbackTrigger {
	Explicit = 'explicit',
	Implicit = 'implicit',
}

export const enum FeedbackReason {
	GToolImages = 'g-tool-images',
	GToolVideo = 'g-tool-video',
	ChatExperience = 'chat-experience',
}
